import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";

import {AppComponent} from "./app.component";

/**
 *  DO NOT DECLARE ANYTHING IN HERE. THIS IS NOT IN USE.
 *  AUTOMATIC DECLARATIONS IN HERE BREAK THE BUILD.
 *  PIPES, COMPONENTS AND SUCH MUST NOT BE DECLARED MULTIPLE TIMES.
 */

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts